/**
 * @generated SignedSource<<80b4d1085b59b4a64db8f5a84f3d61fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AutoSendToEveryone_note$data = {
  readonly stream: {
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"AutoSendToEveryone_autoShareIsSetToEveryone_note">;
  readonly " $fragmentType": "AutoSendToEveryone_note";
};
export type AutoSendToEveryone_note$key = {
  readonly " $data"?: AutoSendToEveryone_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"AutoSendToEveryone_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AutoSendToEveryone_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "AutoSendToEveryone_autoShareIsSetToEveryone_note",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteStream",
          "kind": "LinkedField",
          "name": "stream",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "meetingRecapAutoShareSource",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "sendTo_S",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendTo",
                      "storageKey": null
                    }
                  ],
                  "type": "StreamMeetingRecapAutoShareSettings",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": "sendTo_U",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "sendTo",
                      "storageKey": null
                    }
                  ],
                  "type": "UserMeetingRecapAutoShareSettings",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "84de8d9aede6a1d90956cafd3573c2d9";

export default node;
